import CustomToast from '../../../util-functions/customToast.jsx'


class GtFormHelpers_submitHelper {
  static submit_helper(isPush_todw,draftData,product_master_skus,formName,old_preOpso,isExtended) {
    
    let isExtend = draftData?.IsExtended;
    let isError = false;
    let isPromotion = false
    if(isExtend === true){
      let temp_arr = old_preOpso?.project_codes.length>0 ?old_preOpso?.project_codes : []
      let temp_arr_prom = draftData?.PreOpso.Promotions.length>0 ?draftData?.PreOpso.Promotions : [];
      if(temp_arr.length !== temp_arr_prom.length) {
        CustomToast('error','current promotion project codes is greater than previous promotion')
        return false
      }
     let isNotExist = temp_arr_prom.filter((codes,codes_index)=> {
        return !temp_arr.includes(codes.ProjectCode)       
      })
      if(isNotExist.length>0){
      CustomToast('error','You just change the activity codes')
      return false
      }
    }
    if (draftData?.ActivityMetadata?.product_detail?.promotion_type === 'b0107ffd-5026-4011-bdc6-3bb2e5986332'//gifts
    ) {
        // alert('ANP')
        let anp_data;
        if (draftData?.PreOpso?.Promotions[0]) {
          anp_data = {
            TotalVolume: draftData?.PreOpso?.Promotions[0].TotalVolume,
            TotalBudget: null,
            TotalCost: draftData?.PreOpso?.Promotions[0].TotalCost ,
            OtherDetails: draftData?.PreOpso?.Promotions[0].OtherDetails
          }
         }
        //  draftData?.ActivityMetadata?.product_detail?.master_skus.forEach((item,index) => {
        //  })
          for(let i=0;i<draftData?.PreOpso?.Promotions.length;i++){
            let val = draftData?.PreOpso?.Promotions[i]
            if(!val.TotalVolume  || !val.TotalCost || !val.OtherDetails){
              CustomToast('error',"Required fields are empty!")
            //   this.setState({isLoading:false})
              return false
          } 
         else{
            return isPush_todw === true ? 'push_to_dw'
            // this.push_to_dwh()
          : {key:'submit_approval',pair:anp_data}
        //    this.props.post_submitApproval(draftData?.guid,anp_data)
          }
        }
        return
  
      }
      else if(draftData?.ActivityMetadata?.product_detail?.promotion_type==="9263860e-1fe7-4e7c-aa7b-4da4f98f7def"//tpr
              || draftData?.ActivityMetadata?.product_detail?.promotion_as === "9263860e-1fe7-4e7c-aa7b-4da4f98f7def"
              || draftData?.ActivityMetadata?.product_detail?.promotion_type==="5a0cbfe9-1350-4b5e-bb05-a3d75a7205c9" ){ //MT
            let sku_level_error=false
            
            let datasku = []
          let matchmsku = []
      let main_chunk = draftData?.PreOpso?.Promotions;
      for(let i=0;i<draftData?.PreOpso?.Promotions.length;i++){
          isPromotion=true
          isError=false 
      // draftData?.PreOpso?.Promotions.forEach((e,i) => {
          let val = draftData?.PreOpso?.Promotions[i]
        
          if (val.BuyType === null) {
            CustomToast('error',`Buy Type Of Project Code " ${val.ProjectCode} " may not be empty`)
            // return false;
            // let isError = true;
            return false;
          } else if (val.BuyUom === null && val.BuyType !== "795f46df-01a3-48f9-9143-06ea6c2cf658") {
            
            CustomToast('error',`Buy Uom Of Project Code " ${val.ProjectCode} " may not be empty`)
            // return false;
            // let isError = true;
            return false;
          } else if (val.BuyTo === null || val.BuyTo === "" || !val.BuyTo) {
            
            CustomToast('error',`Buy To Of Project Code " ${val.ProjectCode} " may not be empty`)
            // this.setState({ isLoading: false });
             isError = true;
            return false;
          } else if (
            val.BuyFrom === null ||
            val.BuyFrom === "" ||
            val.BuyFrom === NaN ||       // eslint-disable-line
            !val.BuyFrom
          ) {;
            CustomToast('error',`Buy From Of Project Code " ${val.ProjectCode} " may not be empty`)
            // this.setState({ isLoading: false });
             isError = true;
            return false;
          } else if (val.Norm === null || !val.Norm) {
            
            CustomToast('error',`Norm Of Project Code " ${val.ProjectCode} " may not be empty`)
            // this.setState({ isLoading: false });
             isError = true;
            return false;
          }
          else if (val.NormType === null || !val.NormType) {
           
            CustomToast('error',`Norm Of Project Code " ${val.ProjectCode} " may not be empty`)
            // this.setState({ isLoading: false });
             isError = true;
            return false;
          }
          else if (val.ApplyOn === null || !val.ApplyOn) {
           
            CustomToast('error',`Apply On Of Project Code " ${val.ProjectCode} " may not be empty `)
            // this.setState({ isLoading: false });
             isError = true;
            return false;
          } else if ((val.ApplyOn !== "47bf77b7-8768-4718-9e42-9a36bc2bfcaf" &&
            val.NormType === "b2e41bb3-a11d-48f1-b041-b9c04c956e7a" && val.ApplyUom === null) ||
            (val.BuyType !== "795f46df-01a3-48f9-9143-06ea6c2cf658" &&
              val.NormType !== '2a48252b-4179-4090-98ac-a437728d5ed6' && val.ApplyUom === null)) {
           
            CustomToast('error',`Apply Uom Of Project Code " ${val.ProjectCode} " may not be empty `)
            // this.setState({ isLoading: false });
             isError = true;
            return false;
          }
          else if (val.BuyFrom === null || val.BuyFrom === "" || val.BuyFrom === NaN || !val.BuyFrom) {       // eslint-disable-line
            CustomToast('error',`Buy From Of Project Code " ${val.ProjectCode} " may not be empty`)
            // this.setState({ isLoading: false });
             isError = true
            return false;
          }
          else if(val.Norm===null || !val.Norm || val.Norm <= 0){
              CustomToast('error',`Norm of Project Code " ${val.ProjectCode} " must be > 0  `)
            //   this.setState({isLoading:false});
               isError= true
              return false;
          }        
          else if(val.ApplyOn!=='47bf77b7-8768-4718-9e42-9a36bc2bfcaf' && val.ApplyUom===null){
              CustomToast('error',`Apply Uom Of Project Code " ${val.ProjectCode} " may not be empty because Apply On is per tier`)
              //   this.setState({isLoading:false});
               isError= true
              return false;
          } 
          
          // let resmsku;
          let finalRes= []
          let dummy_arr = draftData?.ActivityMetadata?.product_detail?.master_skus?
          draftData?.ActivityMetadata?.product_detail?.master_skus : [];
          dummy_arr.forEach((msku,ind ) => {
            
            // datasku.push(msku)
            let flag = false
            val.SkuVolumeAnalysis.forEach(preopso => {
              if( preopso.MasterSku === msku){
             flag=true;
            //  break;
            matchmsku.push(msku)
                // datas              
              }
          
        
            })
            if(flag === false){
              let res = datasku.includes(msku)
               res === false && datasku.push(msku)
            }
          })
          // let res_arr = []
          let last_ind = main_chunk.indexOf(main_chunk[main_chunk.length-1])
          // if(last_ind)
          if(i == last_ind){       // eslint-disable-line
          datasku.forEach(res => {
            let isRes = false;
              matchmsku.forEach(matchres => {
                if(res === matchres){
                  isRes = true
                }
              })
              if(isRes === false){ finalRes.push(res)}
  
            })
          }
          product_master_skus.forEach(api => {       // eslint-disable-line
              finalRes.forEach(elem => {
                if(elem === api.guid){
                  CustomToast('error',`Pre-OPSO details of ${api.Description} ${api.Code} are not available with us. Please remove them from Product Detail section to proceed further.`)
                  isError= true;
                //   this.setState({isLoading:false})
                  return false
                }
              })
              })
          val.SkuVolumeAnalysis.find((sku_elem,ind)=>{       // eslint-disable-line
  
            let baseline = sku_elem.Baseline;
            let baseline_string = baseline.toString();
            baseline_string = baseline_string.split('.');
            baseline_string = baseline_string[1];
  
            let aws = sku_elem.ActivatedAws;
            let aws_string = aws.toString();
            aws_string = aws_string.split('.');
            aws_string = aws_string[1]
  
            let postAws = sku_elem.PostAws;
            let postAws_string = postAws.toString();
            postAws_string = postAws_string.split('.');
            postAws_string = postAws_string[1]
  
  
            if (!sku_elem.TotalCost || sku_elem.TotalCost === null || sku_elem.TotalCost === NaN) {       // eslint-disable-line
  
              CustomToast('error',`Total Cost of MSKU ${ind + 1} of Project Code ${val.ProjectCode} is not valid `)
            //   this.setState({ isLoading: false });
              sku_level_error = true;
              return false;
            } if (baseline_string && baseline_string.length > 2) {
              CustomToast('error',`Ensure that Baseline no more than 2 decimal at msku ${ind + 1} in ${val.ProjectCode} Project code`)
              //   this.setState({ isLoading: false });
              sku_level_error = true;
              return false;
            } if (aws_string && aws_string.length > 2) {
              CustomToast('error',`Ensure that Incremental Aws no more than 2 decimal at msku ${ind + 1} in ${val.ProjectCode} Project code`)
              //   this.setState({ isLoading: false });
              sku_level_error = true;
              return false;
            } if (postAws_string && postAws_string.length > 2) {
              CustomToast('error',`Ensure that Post Aws no more than 2 decimal at msku ${ind + 1} in ${val.ProjectCode} Project code`)
              //   this.setState({ isLoading: false });
              sku_level_error = true;
              return false;
            }
  
          })
        }
      if(isError === true || sku_level_error === true){return false}
      if(isError===false && isPromotion===true && sku_level_error === false){
          // let data= {Promotion:draftData?.PreOpso?.Promotions}
        //   setTimeout(() => {
           return isPush_todw === true ? 'push_to_dw'
              : 'submit_approval_without_param'
            //   this.props.post_submitApproval(draftData ?.guid, '')
        //   }, 100);
          // this.setState({isLoading:false});
        };
      }
      //promotion_as: "137c2b2d-c068-44f6-b1d1-8cd0eda535e5"
      else if(draftData?.ActivityMetadata?.product_detail?.promotion_type==="137c2b2d-c068-44f6-b1d1-8cd0eda535e5"//sbb
      || draftData?.ActivityMetadata?.product_detail?.promotion_as === "137c2b2d-c068-44f6-b1d1-8cd0eda535e5"){
       let main_chunk = draftData?.PreOpso?.Promotions
        let datasku = []       // eslint-disable-line
        let matchmsku = []       // eslint-disable-line
        for(let i=0;i<draftData?.PreOpso?.Promotions.length;i++){
          let isError_cont = false;
          // let missed_cont=false;
          let isMskuError=false;
          let val = draftData?.PreOpso?.Promotions[i]
        //   if(val.Norm===null || !val.Norm || val.Norm <= 0){
        //     this.setState({isLoading:false});
        //     let isError= true
        //     return false;
        // }
        let slabFrom=true;
        let datasku = []
        let matchmsku = []
        // let resmsku;
        let finalRes= []
        let dummy_arr = draftData?.ActivityMetadata?.product_detail?.master_skus?
        draftData?.ActivityMetadata?.product_detail?.master_skus : [];
        dummy_arr.forEach((msku,ind ) => {
          
          // datasku.push(msku)
          let flag = false
          val.SkuVolumeAnalysis.forEach(preopso => {
            if(  preopso.MasterSku === msku){
           flag=true;
          //  break;
          matchmsku.push(msku)
              // datas              
            }
        
      
          })
          if(flag === false){
            let res = datasku.includes(msku)
             res === false && datasku.push(msku)
          }
        })
        // let res_arr = []
        let last_ind = main_chunk.indexOf(main_chunk[main_chunk.length-1])
        // if(last_ind)
        if(i == last_ind){       // eslint-disable-line
        datasku.forEach(res => {
          let isRes = false;
            matchmsku.forEach(matchres => {
              if(res === matchres){
                isRes = true
              }
            })
            if(isRes === false){ finalRes.push(res)}
  
          })
        }
        product_master_skus.forEach(api => {
            finalRes.forEach(elem => {
              if(elem === api.guid){
                CustomToast('error',`${api.Description} ${api.Code} msku is not in preopso`)
                isMskuError= true;
                return false
              }
            })
            })
        if(!val.BuyUom && val.SlabType !== "795f46df-01a3-48f9-9143-06ea6c2cf658"){
          CustomToast('error','Buy Uom may not be empty')
          slabFrom=false;
        //   this.setState({isLoading:false})
          return false
        }
          let arr = [0];
          // let sub_arr = [0];
          val.Slabs.forEach((e, i) => {
            if (e.SlabFrom <= 0) {
              CustomToast('error','Slab From must be > 0')
              slabFrom = false
              return false
            }
            arr.push(e.Contribution);
  
          });
          let slabsLevel_cont = arr.reduce((a, b) => {
            return a + b;
          });
          isError_cont =
            isError_cont !== true && slabsLevel_cont === 100 ? false : true;
          slabsLevel_cont !== 100 && slabFrom === true &&
            
            CustomToast('error',`Sum of Contributions Value at Project Code ${i + 1} Should be 100 instead of ${slabsLevel_cont}`)
          if (slabsLevel_cont !== 100) {
            // this.setState({ isLoading: false });
            return false;
          } else {
            if (slabFrom === true) {
              val.SkuVolumeAnalysis.find((e, ind) => {       // eslint-disable-line
                if (e.TotalCost === NaN || e.TotalCost === null || !e.TotalCost) {       // eslint-disable-line
                  CustomToast('error',`Total Cost of MSKU No: ${ind + 1} is not valid`)
                  slabFrom = false;
                  return false;
                }
                let skuLevel_cont = e.Contributions.reduce((a, b) => {
                  return a + b;
                });
                isError_cont =
                  isError_cont !== true && skuLevel_cont === 100 ? false : true;
                skuLevel_cont !== 100 && slabFrom === false &&
                 
                  CustomToast('error',`Sum of Contributions Value at MSKU ${ind + 1} Should be 100 instead of ${skuLevel_cont}`)
                if (skuLevel_cont !== 100) {
                  return false;
                }
                let sku_elem = e
                let baseline = sku_elem.Baseline;
                let baseline_string = baseline.toString();
                baseline_string = baseline_string.split('.');
                baseline_string = baseline_string[1];
  
                let aws = sku_elem.ActivatedAws;
                let aws_string = aws.toString();
                aws_string = aws_string.split('.');
                aws_string = aws_string[1]
  
                let postAws = sku_elem.PostAws;
                let postAws_string = postAws.toString();
                postAws_string = postAws_string.split('.');
                postAws_string = postAws_string[1]
  
  
                if (baseline_string && baseline_string.length > 2) {
                  CustomToast('error',`Ensure that Baseline no more than 2 decimal at msku ${ind + 1} in ${val.ProjectCode} Project code`)
                  //   this.setState({ isLoading: false });
                  // sku_level_error = true;
                  slabFrom = false;
                  return false;
                } if (aws_string && aws_string.length > 2) {
                  CustomToast('error',`Ensure that Incremental Aws no more than 2 decimal at msku ${ind + 1} in ${val.ProjectCode} Project code`)
                  //   this.setState({ isLoading: false });
                  slabFrom = false;
                  return false;
                } if (postAws_string && postAws_string.length > 2) {
                  CustomToast('error',`Ensure that Post Aws no more than 2 decimal at msku ${ind + 1} in ${val.ProjectCode} Project code`)
                  //   this.setState({ isLoading: false });
                  slabFrom = false;
                  return false;
                }
                // })
              });
            }
          }
          if (isError_cont === true) {
            // this.setState({ isLoading: false });
            return false;
          } 
      
          if(isError_cont===true||slabFrom===false||isMskuError===true){return false}
          else{
            return isPush_todw === true ?  'push_to_dw'
            :  'submit_approval_without_param'
          }
  
  
        }
      }
      else if(draftData?.ActivityMetadata?.product_detail?.promotion_type==="88a78f88-99fd-4095-bddf-30aebe350dcd"//mtfts
              || draftData?.ActivityMetadata?.product_detail?.promotion_as === "88a78f88-99fd-4095-bddf-30aebe350dcd" ){
            let sku_level_error=false
            let datasku = []
            let matchmsku = []
          let main_chunk = draftData?.PreOpso?.Promotions
      for(let i=0;i<draftData?.PreOpso?.Promotions.length;i++){
          isPromotion=true
      // draftData?.PreOpso?.Promotions.forEach((e,i) => {
          let val = draftData?.PreOpso?.Promotions[i]
         
        
          // let resmsku;
          let finalRes= []
          let dummy_arr = draftData?.ActivityMetadata?.product_detail?.master_skus?
          draftData?.ActivityMetadata?.product_detail?.master_skus : [];
          dummy_arr.forEach((msku,ind ) => {
            
            // datasku.push(msku)
            let flag = false
            val.SkuVolumeAnalysis.forEach(preopso => {
              if(  preopso.MasterSku === msku){
             flag=true;
            //  break;
            matchmsku.push(msku)
                // datas              
              }
          
        
            })
            if(flag === false){
              let res = datasku.includes(msku)
               res === false && datasku.push(msku)
            }
          })
          // let res_arr = []
          let last_ind = main_chunk.indexOf(main_chunk[main_chunk.length-1])
          // if(last_ind)
          if(i==last_ind){       // eslint-disable-line
          datasku.forEach(res => {
            let isRes = false;
              matchmsku.forEach(matchres => {
                if(res===matchres){
                  isRes = true
                }
              })
              if(isRes === false){ finalRes.push(res)}
  
            })
          }
          product_master_skus.forEach(api => {       // eslint-disable-line
              finalRes.forEach(elem => {
                if(elem===api.guid){
                  CustomToast('error',`${api.Description} ${api.Code} msku is not in preopso`)
                  isError= true;sku_level_error=true;
                  return false
                }
              })
              })
          if (val.BuyType === null) {
            
            CustomToast('error',`Buy Type Of Project Code " ${val.ProjectCode} " may not be empty`)
            // this.setState({ isLoading: false });
             isError = true;
            return false;
          } else if (val.BuyUom === null && val.BuyType !== "795f46df-01a3-48f9-9143-06ea6c2cf658") {
          
            CustomToast('error',`Buy Uom Of Project Code " ${val.ProjectCode} " may not be empty`)
            isError = true;
            return false;
          } else if (val.BuyTo === null || val.BuyTo === "" || !val.BuyTo) {
           
            CustomToast('error',`Buy To Of Project Code " ${val.ProjectCode} " may not be empty`)
           isError = true;
            return false;
          } else if (
            val.BuyFrom === null ||
            val.BuyFrom === "" ||
            val.BuyFrom === NaN ||       // eslint-disable-line
            !val.BuyFrom
          ) {
            
            CustomToast('error',`Buy From Of Project Code " ${val.ProjectCode} " may not be empty`)
            isError = true;
            return false;
          } else if (val.Norm === null || !val.Norm || val.Norm <= 0) {
            CustomToast('error',`Norm of Project Code " ${val.ProjectCode} " must be > 0 `)
           isError = true;
            return false;
          }
          else if (val.NormType === null || !val.NormType) {
           
            CustomToast('error',`Norm Of Project Code " ${val.ProjectCode} " may not be empty`)
            isError = true;
            return false;
          }
          else if (val.ApplyOn === null || !val.ApplyOn) {
           
            CustomToast('error',`Apply On Of Project Code " ${val.ProjectCode} " may not be empty `)
            isError = true;
            return false;
          } else if (val.ApplyOn !== "47bf77b7-8768-4718-9e42-9a36bc2bfcaf" && val.ApplyUom === null && val.BuyType !== "795f46df-01a3-48f9-9143-06ea6c2cf658") {
           
            CustomToast('error',`Apply Uom Of Project Code " ${val.ProjectCode} " may not be empty because Apply On is per tier`)
            isError = true;
            return false;
          }
          else if (val.BuyFrom === null || val.BuyFrom === "" || val.BuyFrom === NaN || !val.BuyFrom) {       // eslint-disable-line
            CustomToast('error',`Buy From Of Project Code " ${val.ProjectCode} " may not be empty`)
            isError = true
            return false;
          }
          else if (val.Norm === null || !val.Norm) {
            CustomToast('error',`Norm Of Project Code " ${val.ProjectCode} " may not be empty`)
            isError = true
            return false;
          }
          else if ((val.ApplyOn !== '47bf77b7-8768-4718-9e42-9a36bc2bfcaf' ||
            val.NormType === "b2e41bb3-a11d-48f1-b041-b9c04c956e7a") && val.ApplyUom === null) {
            CustomToast('error',`Apply Uom Of Project Code " ${val.ProjectCode} " may not be empty `)
            isError = true
            return false;
          }
  
        //   val.SkuVolumeAnalysis.find((sku_elem, ind) => {
        //     if (sku_elem.TotalCost === null || sku_elem.TotalCost === NaN || !sku_elem.TotalCost) {
  
        //     //   this.setState({ isLoading: false });
        //       sku_level_error = true;
        //       return false;
        //     }
        //   })
          val.SkuVolumeAnalysis.find((sku_elem,ind)=>{       // eslint-disable-line
  
            let baseline = sku_elem.Baseline;
            let baseline_string = baseline.toString();
            baseline_string = baseline_string.split('.');
            baseline_string = baseline_string[1];
  
            let aws = sku_elem.ActivatedAws;
            let aws_string = aws.toString();
            aws_string = aws_string.split('.');
            aws_string = aws_string[1]
  
            let postAws = sku_elem.PostAws;
            let postAws_string = postAws.toString();
            postAws_string = postAws_string.split('.');
            postAws_string = postAws_string[1]
  
  
            if (!sku_elem.TotalCost || sku_elem.TotalCost === null || sku_elem.TotalCost === NaN) {       // eslint-disable-line
  
              CustomToast('error',`Total Cost of MSKU ${ind + 1} of Project Code ${val.ProjectCode} is not valid `)
            //   this.setState({ isLoading: false });
              sku_level_error = true;
              return false;
            } if (baseline_string && baseline_string.length > 2) {
              CustomToast('error',`Ensure that Baseline no more than 2 decimal at msku ${ind + 1} in ${val.ProjectCode} Project code`)
              //   this.setState({ isLoading: false });
              sku_level_error = true;
              return false;
            } if (aws_string && aws_string.length > 2) {
              CustomToast('error',`Ensure that Incremental Aws no more than 2 decimal at msku ${ind + 1} in ${val.ProjectCode} Project code`)
              //   this.setState({ isLoading: false });
              sku_level_error = true;
              return false;
            } if (postAws_string && postAws_string.length > 2) {
              CustomToast('error',`Ensure that Post Aws no more than 2 decimal at msku ${ind + 1} in ${val.ProjectCode} Project code`)
              //   this.setState({ isLoading: false });
              sku_level_error = true;
              return false;
            }
  
          })
        }
        if (isError === false && isPromotion === true && sku_level_error === false) {
          // let data= {Promotion:draftData?.PreOpso?.Promotions}
        //   setTimeout(() => {
            if (formName === "mt") {
                return isPush_todw === true ?  'push_to_dw'
                : 'mtfts_submit_approval_without_param'
                //  this.props.post_mtfts_submitApproval(draftData ?.guid, "");
            } else {
                return isPush_todw === true ?  'push_to_dw'
                :  'submit_approval_without_param'
            }
        //   }, 100);
          // this.setState({isLoading:false});
        }else return false;
      }
     
      else {
        if (formName === "mt") {
            return isPush_todw === true ?  'push_to_dw'
            : 'mtfts_submit_approval_without_param'
        } else {
            return isPush_todw === true ?  'push_to_dw'
            :  'submit_approval_without_param'
        }
      }
      
  }
}
 
export default GtFormHelpers_submitHelper;